module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/kv_bg-1dc62f5a46b4dfb96567d3b746743d12.jpg";